import React, { useContext, useState, useEffect } from 'react';
import { auth } from '../FirebaseUtils';
import { 
    onAuthStateChanged, 
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    sendPasswordResetEmail,
    updateEmail,
    updatePassword,
} from "firebase/auth";

export const AuthContext = React.createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState();

    /*
        loading is the trick of waiting this AuthProvider to be ready
        before rendering all the other child component.

        Child components start rendering when this provider did mount,
        so that when they call to useAuth, the value is ready.
    */
    const [loading, setLoading] = useState(true);
        
    const value = {
        currentUser,
        signupWithEmailAndPassword,
        loginWithEmailAndPassword,
        logout,
        resetPassword,
        updateUserEmail,
        updateUserPassword,
    }

    useEffect(() => {
        // auth.onAuthStateChanged(user => {
        //     setCurrentUser(user);
        // });
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User
                const uid = user.uid;
                setCurrentUser(user);

                //console.log('AuthProvider useEffect - onAuthStateChanged, user is valid, ' + JSON.stringify(user));
                
                setLoading(false);
                //unsubscribe();
                // ...
            } else {
                // User is signed out
                setCurrentUser(null);

                //console.log('AuthProvider useEffect - onAuthStateChanged, user is null');

                setLoading(false);
                //unsubscribe();
            }
        });

        return unsubscribe;
    }, []);

    function signupWithEmailAndPassword(email, password) {
        // This returns a promise
        return createUserWithEmailAndPassword(auth, email, password);
    }

    function loginWithEmailAndPassword(email, password) {
        return signInWithEmailAndPassword(auth, email, password);
    }

    function loginAnonymously() {

    }

    function logout() {
        return signOut(auth);
    }

    function resetPassword(email) {
        return sendPasswordResetEmail(auth, email);
    }

    function updateUserEmail(email) {
        return updateEmail(currentUser, email);
    }

    function updateUserPassword(password) {
        return updatePassword(currentUser, password);
    }

    return (
        <AuthContext.Provider value={value}>
            { loading ? null : children }
            { /* children */ }
        </AuthContext.Provider>
    );
}
